import * as React from 'react';
import './List.scss';
import classNames from 'classnames';

export type ListProps = {
    children: React.ReactNode;
    className?: string;
};

export const List: React.FunctionComponent<ListProps> = ({ children, className }) => (
    <ul className={classNames(className, 'List')}>{children}</ul>
);
